import * as React from "react";
const AppsMenuIcon = (props) => (
  <svg width={92} height={92} viewBox="0 0 92 92" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <rect
        strokeWidth={10}
        height={32}
        width={32}
        y={6}
        x={6}
        stroke="currentColor"
        fill="transparent"
        rx={3}
      />
      <rect
        strokeWidth={10}
        height={32}
        width={32}
        y={6}
        x={54}
        stroke="currentColor"
        fill="transparent"
        rx={3}
      />
      <rect
        strokeWidth={10}
        height={32}
        width={32}
        y={54}
        x={6}
        stroke="currentColor"
        fill="transparent"
        rx={3}
      />
      <rect
        strokeWidth={10}
        height={32}
        width={32}
        y={54}
        x={54}
        stroke="currentColor"
        fill="transparent"
        rx={3}
      />
    </g>
  </svg>
);
export default AppsMenuIcon;
